/**
 * Loading screen — brief fallback if user clicks DISCOVER before assets load.
 * Matches the sunset palette.
 */
export default function LoadingScreen() {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-b from-[#0d0d1a] to-[#1a1025]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-[3px] border-[#ff6b4a]/30 border-t-[#ffd93d] rounded-full animate-spin" />
        <p className="font-['Outfit'] text-[#a0a0c0] text-sm font-medium">
          Loading the festival...
        </p>
      </div>
    </div>
  );
}
